import CrashdownData from 'CrashdownData'
import * as React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { IProps as IOriginalProps } from '../Checkout/MembershipCheckoutForm'
import { TwoYearCheckout } from './components/TwoYearCheckout'

class WrappedTwoYearCheckout extends React.Component<IOriginalProps, {}> {
  public render() {
    return (
      <StripeProvider apiKey={CrashdownData.stripe.publishableKey}>
        <Elements>
          <TwoYearCheckout {...this.props} />
        </Elements>
      </StripeProvider>
    )
  }
}

export { WrappedTwoYearCheckout as TwoYearCheckout }
